import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/customfields/$id')({
  // A bare `/customfields/$id` now opens the edit drawer (the detail view was
  // absorbed into the cards). This route is ALSO the parent of `/$id/edit`, and
  // a parent `beforeLoad` runs for its child routes too — so redirecting
  // unconditionally sent `/$id/edit` back to itself in an infinite redirect
  // loop that froze the tab. Only redirect the bare path; let `/edit` through.
  beforeLoad: ({ params, location }) => {
    if (location.pathname.replace(/\/+$/, '').endsWith('/edit')) return;
    throw redirect({
      to: '/dashboard/settings/customfields/$id/edit',
      params: { id: params.id },
    });
  },
});
